import React, { useState } from "react";
import { cellWidth } from "../../../../core/methods/tableCellWidth";
import {
  parseDate,
  parseDaysString,
  parseNumber,
  safeLocaleCompare,
} from "../../../../core/methods/sorterMethods";
import { ColumnsType } from "antd/es/table";
import FiltersTrackCase, {
  FiltersSelectType,
  initialFilterSelect,
  SearchFormDataType,
} from "../FiltersTrackCase";
import Datatable from "../../../../core/common/dataTable";
import { dummyData_recheckReport } from "../../../../core/data/js/dummy-data";
import { formattedDate } from "../../../../core/methods/formattedDate";

const RecheckReports = () => {
  const [itemList, setItemList] = useState(dummyData_recheckReport);
  const [searchFilter, setSearchFilter] = useState<SearchFormDataType>({
    case_id: "",
    applicant_name: "",
    email: "",
    from_date: "",
    to_date: "",
  });
  const [filterData, setFilterData] = useState<FiltersSelectType>(initialFilterSelect);

  // const [selectedRows, setSelectedRows] = useState<any[]>([]);

  // ---- columns ----
  const columns: ColumnsType<any> = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      align: "center",
      sorter: false,
    },
    {
      title: "Applicant Name",
      dataIndex: "applicantName",
      key: "applicantName",
      onCell: () => cellWidth(200),
      sorter: (a: any, b: any) => safeLocaleCompare(a, b, "applicantName"),
    },
    {
      title: "Case ID",
      dataIndex: "caseId",
      key: "caseId",
      sorter: (a: any, b: any) => parseNumber(a.caseId) - parseNumber(b.caseId),
    },
    {
      title: "Ageing",
      dataIndex: "ageing",
      key: "ageing",
      sorter: (a: any, b: any) =>
        parseDaysString(a.ageing) - parseDaysString(b.ageing),
    },
    {
      title: "Report Type",
      dataIndex: "reportType",
      key: "reportType",
      sorter: (a: any, b: any) => safeLocaleCompare(a, b, "reportType"),
    },
    {
      title: "Recheck Date",
      dataIndex: "recheckDate",
      key: "recheckDate",
      onCell: () => cellWidth(180),
      render: (text: string) => {
        const date = formattedDate(text) ?? "-";
        return <span>{date}</span>
      },
      sorter: (a: any, b: any) =>
        parseDate(a.recheckDate).getTime() - parseDate(b.recheckDate).getTime(),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      onCell: () => cellWidth(190),
      render: (status: string) => (
        <span className="badge bg-soft-secondary">{status}</span>
      ),
      sorter: (a: any, b: any) => safeLocaleCompare(a, b, "status"),
    },
  ];

  return (
    <>
      {/* filters */}
      <FiltersTrackCase
        filterData={filterData}
        searchFilter={searchFilter}
        setFilterData={setFilterData}
        setSearchFilter={setSearchFilter}
      />
      {/* Table  */}
      <div className="card mt-3">
        <Datatable
          rowKey="sno"
          dataSource={itemList}
          columns={columns}
        // Selection={true}
        // onSelectionChange={(rows) => {
        //   setSelectedRows(rows);
        // }}
        // rowSelection={(op: any) => console.log(op)}
        // pagination={pagination}
        // handleTableChange={handleTableChange}
        />
      </div>
    </>
  );
};

export default RecheckReports;
